import { array, string } from "yup";
import { ALL_LEAF_IDS } from "@academy-context/shared/domain/types/enums/specializations";
import { REQUIRED_FIELD } from "@shared-kernel/primary/forms/constants";

export const SPECIALIZATIONS_MAX = 20;
export const SPECIALIZATIONS_MIN_ERROR = "Au moins une spécialité est requise";
export const SPECIALIZATIONS_MAX_ERROR = `Vous ne pouvez pas sélectionner plus de ${SPECIALIZATIONS_MAX} spécialités`;
export const SPECIALIZATION_UNKNOWN_ERROR = "Spécialité inconnue";

export const specializationLeafIdSchema = string()
  .oneOf([...ALL_LEAF_IDS], SPECIALIZATION_UNKNOWN_ERROR)
  .required(REQUIRED_FIELD);

export const specializationsArraySchema = array(specializationLeafIdSchema)
  .transform((value, original) => (original == null ? [] : value))
  .min(1, SPECIALIZATIONS_MIN_ERROR)
  .max(SPECIALIZATIONS_MAX, SPECIALIZATIONS_MAX_ERROR)
  .required(SPECIALIZATIONS_MIN_ERROR);
